import { TransactionTypes } from '@/modules/common/services/http/affiliate';
import {
  ETransactionType,
  ETradeMovementStatus
} from '@/modules/common/services/graphql/server/server.sdk';
import { Withdraw } from '@/modules/transaction/services/withdraws';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

/** This method adds an interaction because we only open the details of the transactions
 * when they are pending or like allowedTypes
 */
export const ALLOWED_TYPES = [
  'payment',
  'transfer',
  'withdraw',
  'chargingfees',
  'exchangetransfer'
];
const PENDING_STATUS = ['pending', 'processing'];

export function hasDetails(detailType: string, status: string): boolean {
  const isTradePriceOrderModalEnabled = FeatureFlagsModule.isEnabled(
    FeatureFlags.TRADE_ENABLE_PRICE_ORDER_MODAL
  );
  if (!detailType) {
    return false;
  }

  if (
    detailType.toLocaleLowerCase() ===
    ETransactionType.Order.toLocaleLowerCase()
  ) {
    return (
      status.toLocaleLowerCase() ===
        ETradeMovementStatus.Filled.toLocaleLowerCase() ||
      status.toLocaleLowerCase() ===
        ETradeMovementStatus.Rejected.toLocaleLowerCase()
    );
  }

  if (
    detailType.toLocaleLowerCase() ===
      ETransactionType.AssetTransfer.toLocaleLowerCase() &&
    isTradePriceOrderModalEnabled
  ) {
    ALLOWED_TYPES.push('asset_transfer');
  }

  const isPending = PENDING_STATUS.includes(status.toLocaleLowerCase());
  const isAllowedType = ALLOWED_TYPES.includes(detailType.toLocaleLowerCase());

  return isPending || isAllowedType;
}

export function getStatus(status: string): string {
  switch (status) {
    case 'accepted':
    case 'EXECUTED':
    case 'ACCEPTED':
    case 'Filled':
      return 'Concluído';
    case 'canceled':
    case 'Canceled':
      return 'Cancelado';
    case 'pending':
    case 'Placing':
    case 'PENDING':
      return 'Pendente';
    case 'processing':
    case 'PROCESSING':
      return 'Processando';
    default:
      return ' — ';
  }
}

export function getTransactionType(type: string): string {
  switch (type) {
    case TransactionTypes.Deposit:
    case TransactionTypes.Invoice:
      return 'Depósito';
    case TransactionTypes.Withdrawal:
      return 'Resgate';
    case TransactionTypes.CashbackReinvestment:
      return 'Cashback';
    case TransactionTypes.Payment:
      return 'Pagamento';
    default:
      return 'Movimentação Interna';
  }
}

export function getWithdrawOperationType(withdraw: Withdraw): string {
  switch (withdraw.withdrawInfo.moduleName) {
    case 'wealth':
      if (withdraw.isWithdrawalByProduct) return 'Resgate de produto';
      else return 'Resgate de carteira';
    case 'cash':
      return 'Resgate de Conta';
    case 'trade':
      return 'Resgate de Bolsa';
    default:
      return '-';
  }
}

export function getDepositOperationType(type: string): string {
  switch (type) {
    case 'product':
      return 'Depósito em produto ';
    case 'portfolio':
      return 'Depósito em carteira ';
    default:
      return '-';
  }
}

export function getDestinationOfWithdrawal(withdraw: Withdraw): string {
  if (withdraw.toWarrenAccount) return 'Conta Warren';
  else return 'Outra conta';
}

export function getDepositMethod(isDepositByInvoice: boolean): string {
  return isDepositByInvoice ? 'Boleto' : 'Transferência bancária';
}
